import { GetMe } from '@/graphql/queries/User.graphql'
import {GetCharacterMeta} from '@/graphql/queries/Character.graphql'

export default {
  computed  : {
    authenticationMethod(){
      return this.$store.state.authentication.method;
    },

    isAuthed(){
      return this.$store.state.authentication.isAuthed;
    },

    loginedUser(){
      return this.$store.state.user.userData;
    },

    loginedCharacter(){
      return this.$store.state.userCharacter.characterData;
    },
  },

  methods   : {
    checkAuthenticationFrontPage(){
      this.setAuthedKey();

      if(this.isAuthed){
        this.$router.push({name:'home'});
      }else{
        this.$emit('afterAuthenication');
      }
    },

    async checkAuthenticationLoginedPage(){
      await this.checkCouldAuth();

      if (this.isAuthed) {
        if (this.routingPosition !== 'registrationConfirmationEmail'){
          await this.shouldGrabUserMeta();
        }
      } else {
        this.$router.push({ name: 'index' });
      }
    },

    async shouldGrabUserMeta(){
      if( (this.loginedUser.name === '') || (this.loginedCharacter.name === '') ){
        if( await this.grabUserMeta() ){
          this.$emit('afterLoginedAuthenication');
        }else{
          this.$emit('afterLoginedAuthenicationFail');
        }
      }else{
        // すでにユーザー情報を所有している場合はスキップします。
        this.$emit('afterLoginedAuthenication');
      }
    },

    async grabUserMeta(){
      let isSucceeded = false;

      await this.$store.dispatch({
        type  : 'globalLoading/updateGlobalLoading',
        value : true,
      });

      // 必ず2.5秒待ちます。
      await this.UXWaiting(2500);

      const result = await this.apolloQueryManually({
        query : GetMe
      });
      // もともと $store.dispatch('user/initializeUserData')

      isSucceeded = await this.apolloResultValidation(result);

      if(isSucceeded){
        // characterMetaも一度取得します。 (キャッシュをするという意味で)
        const result = await this.apolloQueryManually({
          query : GetCharacterMeta
        });
        
        isSucceeded = await this.apolloResultValidation(result);

        await this.$store.dispatch({
          type  : 'globalLoading/updateGlobalLoading',
          value : false,
        });
      }
      
      return isSucceeded;
    },

    async checkCouldAuth(){
      if(this.isAuthed) return;
      
      await this.setAuthedKey();
    },

    async setAuthedKey(){
      let authedKey = null;

      switch(this.authenticationMethod){
        case 'web':
          try{
            const csrfToken = localStorage.getItem('akibatrical_secure_key');
            
            if( (typeof csrfToken !== 'undefined') && (csrfToken !== null) ){
              authedKey = csrfToken;
            }
          }catch(e){
            console.log('[E1001: Unable to get CSRF Token From LocalStorage.]');
          }
        break;
        
        case 'api':
          try{
            const passport = localStorage.getItem('akibatrical_passport');

            if( (typeof passport !== 'undefined') && (passport !== null) ){
              authedKey = JSON.parse(passport);
            }
          }catch(e){
            console.log('[E1002: Unable to get JWT Token From LocalStorage.]');
          }
        break;
      }

      if( (typeof authedKey !== 'undefined') && (authedKey !== null) ){
        await this.$store.dispatch({
          type  : 'authentication/setAuth',
          data  : authedKey,
        });
      }

      this.$store.dispatch({
        type : 'requests/initializeRequest'
      });
    },

    async webApiLogout(uxWaitingTime = 2500){
      await this.$store.dispatch({
        type  : 'globalLoading/updateGlobalLoading',
        value : true,
      });

      await this.$store.dispatch('systemLogout');

      // UXのため一定時間待機します。
      await this.UXWaiting(uxWaitingTime);

      await this.$store.dispatch({
        type  : 'layouts/updateLoginedView',
        value : false,
      });

      this.$store.dispatch({
        type  : 'layouts/updateMountedLayoutStyleName',
        value : 'front'
      });

      await this.$store.dispatch({
        type  : 'globalLoading/updateGlobalLoading',
        value : false,
      });

      Object.values(this.$apollo.provider.clients)
      .forEach(client => client.cache.reset());

      this.$router.push({name: 'index'});
    }
  }
}